/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BaseBlockContent } from "src/components/Block/styles";

export const StyledImageBlockContent = styled(BaseBlockContent)`
  overflow: hidden;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  .loading {
    background: ${({ theme }) => theme.primary};
  }
`;

export const StyledImagePicker = styled.label`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-family: "IBM Plex Mono";
  color: ${({ theme }) => theme.text.subtle};
  cursor: pointer;
  text-decoration: underline;
`;

export const HiddenInput = styled.input`
  display: none;
`;
